var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "table-top" },
        [
          !_vm.disabled
            ? _c("el-button", { on: { click: _vm.addRow } }, [
                _vm._v("添加一行"),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "list_content" },
        _vm._l(_vm.tableData, function (item, index) {
          return _c(
            "div",
            { key: item.id, staticClass: "list_item" },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  refInFor: true,
                  attrs: { "label-width": "120px" },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "商品来源" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "请选择商品来源",
                                    disabled: _vm.disabled,
                                  },
                                  on: {
                                    change: (e) => _vm.sourceChange(index, e),
                                  },
                                  model: {
                                    value: item.productSource,
                                    callback: function ($$v) {
                                      _vm.$set(item, "productSource", $$v)
                                    },
                                    expression: "item.productSource",
                                  },
                                },
                                _vm._l(item.options, function (oitem) {
                                  return _c("el-option", {
                                    key: oitem.dictCode,
                                    attrs: {
                                      label: oitem.dictValue,
                                      value: oitem.dictCode,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "产品名称" } },
                            [
                              item.productSource === "2"
                                ? _c("el-input", {
                                    attrs: {
                                      disabled: _vm.disabled,
                                      placeholder: "请输入产品名称",
                                    },
                                    model: {
                                      value: item.productName,
                                      callback: function ($$v) {
                                        _vm.$set(item, "productName", $$v)
                                      },
                                      expression: "item.productName",
                                    },
                                  })
                                : item.productSource === "1"
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: { width: "100%" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openModal(index)
                                        },
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          readonly: "",
                                          placeholder: "请选择产品名称",
                                          disabled: _vm.disabled,
                                        },
                                        on: {
                                          change: (e) => _vm.changeEvent(),
                                        },
                                        model: {
                                          value: item.productName,
                                          callback: function ($$v) {
                                            _vm.$set(item, "productName", $$v)
                                          },
                                          expression: "item.productName",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _c("el-input", {
                                    attrs: {
                                      disabled: _vm.disabled,
                                      placeholder: "请输入产品名称",
                                    },
                                    on: { change: (e) => _vm.changeEvent() },
                                    model: {
                                      value: item.productName,
                                      callback: function ($$v) {
                                        _vm.$set(item, "productName", $$v)
                                      },
                                      expression: "item.productName",
                                    },
                                  }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "产品编码" } },
                            [
                              item.productSource === "2"
                                ? _c("el-input", {
                                    attrs: {
                                      disabled: _vm.disabled,
                                      placeholder: "请输入产品编码",
                                    },
                                    on: { change: (e) => _vm.changeEvent() },
                                    model: {
                                      value: item.productCode,
                                      callback: function ($$v) {
                                        _vm.$set(item, "productCode", $$v)
                                      },
                                      expression: "item.productCode",
                                    },
                                  })
                                : item.productSource === "1"
                                ? _c("el-input", {
                                    attrs: {
                                      readonly: "",
                                      disabled: "",
                                      placeholder: "请输入产品编码",
                                    },
                                    on: { change: (e) => _vm.changeEvent() },
                                    model: {
                                      value: item.productCode,
                                      callback: function ($$v) {
                                        _vm.$set(item, "productCode", $$v)
                                      },
                                      expression: "item.productCode",
                                    },
                                  })
                                : _c("el-input", {
                                    attrs: {
                                      readonly: "",
                                      disabled: "",
                                      placeholder: "请输入编码编码",
                                    },
                                    on: { change: (e) => _vm.changeEvent() },
                                    model: {
                                      value: item.productCode,
                                      callback: function ($$v) {
                                        _vm.$set(item, "productCode", $$v)
                                      },
                                      expression: "item.productCode",
                                    },
                                  }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "规格" } },
                            [
                              item.productSource === "2"
                                ? _c("el-input", {
                                    attrs: {
                                      disabled: _vm.disabled,
                                      placeholder: "请输入规格",
                                    },
                                    on: { change: (e) => _vm.changeEvent() },
                                    model: {
                                      value: item.specification,
                                      callback: function ($$v) {
                                        _vm.$set(item, "specification", $$v)
                                      },
                                      expression: "item.specification",
                                    },
                                  })
                                : item.productSource === "1"
                                ? _c("el-input", {
                                    attrs: {
                                      readonly: "",
                                      disabled: "",
                                      placeholder: "请输入规格",
                                    },
                                    on: { change: (e) => _vm.changeEvent() },
                                    model: {
                                      value: item.specification,
                                      callback: function ($$v) {
                                        _vm.$set(item, "specification", $$v)
                                      },
                                      expression: "item.specification",
                                    },
                                  })
                                : _c("el-input", {
                                    attrs: {
                                      readonly: "",
                                      disabled: "",
                                      placeholder: "请输入规格",
                                    },
                                    on: { change: (e) => _vm.changeEvent() },
                                    model: {
                                      value: item.specification,
                                      callback: function ($$v) {
                                        _vm.$set(item, "specification", $$v)
                                      },
                                      expression: "item.specification",
                                    },
                                  }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "商品分类" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "请选择商品分类",
                                    disabled: _vm.disabled,
                                  },
                                  on: { change: (e) => _vm.changeEvent() },
                                  model: {
                                    value: item.displayType,
                                    callback: function ($$v) {
                                      _vm.$set(item, "displayType", $$v)
                                    },
                                    expression: "item.displayType",
                                  },
                                },
                                _vm._l(item.calssOptions, function (pitem) {
                                  return _c("el-option", {
                                    key: pitem.dictCode,
                                    attrs: {
                                      label: pitem.dictValue,
                                      value: pitem.dictCode,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "商品层级" } },
                            [
                              item.productSource === "2"
                                ? _c("el-input", {
                                    attrs: {
                                      disabled: _vm.disabled,
                                      placeholder: "请输入商品层级",
                                    },
                                    on: { change: (e) => _vm.changeEvent() },
                                    model: {
                                      value: item.productHierarchy,
                                      callback: function ($$v) {
                                        _vm.$set(item, "productHierarchy", $$v)
                                      },
                                      expression: "item.productHierarchy",
                                    },
                                  })
                                : item.productSource === "1"
                                ? _c("el-input", {
                                    attrs: {
                                      readonly: "",
                                      disabled: "",
                                      placeholder: "请输入商品层级",
                                    },
                                    on: { change: (e) => _vm.changeEvent() },
                                    model: {
                                      value: item.productHierarchy,
                                      callback: function ($$v) {
                                        _vm.$set(item, "productHierarchy", $$v)
                                      },
                                      expression: "item.productHierarchy",
                                    },
                                  })
                                : _c("el-input", {
                                    attrs: {
                                      readonly: "",
                                      disabled: "",
                                      placeholder: "请输入商品层级",
                                    },
                                    model: {
                                      value: item.productHierarchy,
                                      callback: function ($$v) {
                                        _vm.$set(item, "productHierarchy", $$v)
                                      },
                                      expression: "item.productHierarchy",
                                    },
                                  }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 10 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "开始时间" } },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  type: "datetime",
                                  placeholder: "选择开始时间",
                                  disabled: _vm.disabled,
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                },
                                on: { change: (e) => _vm.changeEvent() },
                                model: {
                                  value: item.startTime,
                                  callback: function ($$v) {
                                    _vm.$set(item, "startTime", $$v)
                                  },
                                  expression: "item.startTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 10 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "结束时间" } },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  type: "datetime",
                                  placeholder: "选择开始时间",
                                  disabled: _vm.disabled,
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                },
                                on: { change: (e) => _vm.changeEvent() },
                                model: {
                                  value: item.endTime,
                                  callback: function ($$v) {
                                    _vm.$set(item, "endTime", $$v)
                                  },
                                  expression: "item.endTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "购买单位" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: _vm.disabled,
                                  placeholder: "请输入购买单位",
                                },
                                on: { change: (e) => _vm.changeEvent() },
                                model: {
                                  value: item.unit,
                                  callback: function ($$v) {
                                    _vm.$set(item, "unit", $$v)
                                  },
                                  expression: "item.unit",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "商品兑换积分" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: _vm.disabled,
                                  placeholder: "请输入商品兑换积分",
                                },
                                on: { change: (e) => _vm.changeEvent() },
                                model: {
                                  value: item.integral,
                                  callback: function ($$v) {
                                    _vm.$set(item, "integral", $$v)
                                  },
                                  expression: "item.integral",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.productType === "3"
                    ? _c(
                        "el-row",
                        { attrs: { gutter: 10 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "现金下单奖励积分",
                                    "label-width": "160px",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      disabled: _vm.disabled,
                                      placeholder: "请输入奖励积分",
                                    },
                                    on: { change: (e) => _vm.changeEvent() },
                                    model: {
                                      value: item.rewardPoint,
                                      callback: function ($$v) {
                                        _vm.$set(item, "rewardPoint", $$v)
                                      },
                                      expression: "item.rewardPoint",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "商品原价/元" } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "number",
                                      disabled: _vm.disabled,
                                      placeholder: "请输入商品原价",
                                    },
                                    on: { change: (e) => _vm.changeEvent() },
                                    model: {
                                      value: item.price,
                                      callback: function ($$v) {
                                        _vm.$set(item, "price", $$v)
                                      },
                                      expression: "item.price",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "商品会员价/元" } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "number",
                                      disabled: _vm.disabled,
                                      placeholder: "请输入商品会员价",
                                    },
                                    on: { change: (e) => _vm.changeEvent() },
                                    model: {
                                      value: item.memberPrice,
                                      callback: function ($$v) {
                                        _vm.$set(item, "memberPrice", $$v)
                                      },
                                      expression: "item.memberPrice",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "商品列表图(1张)" } },
                            [
                              _c("UploadImage", {
                                attrs: {
                                  value: item.imageList,
                                  disabled: _vm.disabled,
                                },
                                on: {
                                  change: (files) =>
                                    _vm.changeFiles(files, index, "one"),
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "详情图(最多10张)" } },
                            [
                              _c("UploadImage", {
                                attrs: {
                                  limit: 10,
                                  value: item.detailedPicture,
                                  disabled: _vm.disabled,
                                },
                                on: {
                                  change: (files) =>
                                    _vm.changeFiles(files, index, "two"),
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        }),
        0
      ),
      _c("SelectConfig", {
        ref: "selectConfig",
        on: { onGetSelect: _vm.onGetSelect },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }